<template>
  <div>
    <h4>Transactions List</h4>
    <div class="justify-content-between d-flex mb-4">
      <div class="d-flex align-items-center">
        <slot name="all-agents"></slot>
        <slot name="all-trans"></slot>
        <div class="filter refresh">
          <span>Refresh</span>
          <img src="./../assets/icons/arrow-down.svg" alt="" />
        </div>
        <div class="filter" @click="toggleFilter">
          <img src="./../assets/icons/filter.svg" alt="" />
          <span>Filter</span>
          <img src="./../assets/icons/arrow-down.svg" alt="" />
        </div>
        <div class="search-form search-form-agent d-flex">
          <slot name="search-bar"></slot>
          <img
            class="eye d-none"
            src="./../assets/icons/eye-visible.svg"
            alt="Search"
          />
          <slot name="search-btn"></slot>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span>Show</span>
        <div class="filter show">
          <slot name="select-entry"></slot>
        </div>
        <slot name="entries-no"></slot>
      </div>
    </div>
    <div
      id="filterModal"
      class="filter-modal"
      :class="{ 'filter-fade': showFilterModal }"
    >
      <div class="filter-param">
        <span>Date</span>
        <b-row class="align-items-center justify-content-between">
          <b-col class="flex-grow-0">
            <slot name="start-date" :closeModal="toggleFilter"></slot>
          </b-col>
          <span>-</span>
          <b-col class="flex-grow-0">
            <slot name="end-date"></slot>
          </b-col>
        </b-row>
      </div>
      <div class="d-none">
        <p>POS Transaction Value (₦)</p>
        <div class="filter-param">
          <b-form-input
            class="mb-3"
            id="range-1"
            type="range"
            min="0"
            max="5"
          ></b-form-input>
          <b-row class="align-items-center">
            <b-col>
              <slot name="start-range"></slot>
            </b-col>
            <span>-</span>
            <b-col>
              <slot name="end-range"></slot>
            </b-col>
          </b-row>
        </div>
        <p>Transaction Status</p>
        <div class="filter-param">
          <b-row class="align-items-center">
            <b-col>
              <slot name="status-input"></slot>
            </b-col>
          </b-row>
        </div>
        <slot name="save-default"></slot>
      </div>
      <div class="filter-param">
        <b-row class="align-items-center">
          <b-col>
            <slot name="clear-btn"></slot>
          </b-col>
          <b-col>
            <slot name="apply-btn" :closeModal="toggleFilter"></slot>
          </b-col>
        </b-row>
      </div>
    </div>
    <slot name="table"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFilterModal: false,
    };
  },
  methods: {
    toggleFilter() {
      this.showFilterModal = !this.showFilterModal;
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu {
  background: #fff;
}
</style>
